module.exports = __webpack_public_path__ + "static/media/Lato-Hairline.c27ae785.eot";